import classnames from 'classnames';
import React from 'react';
import { Form } from 'react-bootstrap';
import { UseFormRegisterReturn } from 'react-hook-form';
import FormLabel from '../FormLabel/FormLabel';
import styles from './radioButton.module.scss';

interface InputProps {
  label: string;
  register: UseFormRegisterReturn;
  className?: string;
  required?: boolean;
  error?: string;
  options: Array<{
    value: string;
    label: string;
  }>;
  disabled?: boolean;
  'data-testid'?: string;
}

const RadioButton = ({
  label,
  register,
  className,
  required,
  error,
  options,
  disabled,
  'data-testid': testId,
}: InputProps) => {
  return (
    <div data-testid={testId} className={classnames(styles.root, className)}>
      {label ? (
        <FormLabel label={label} required={required} error={error} />
      ) : null}
      {options.map((item, index) => (
        <Form.Check
          id={`${register.name}-${item.label}`}
          key={index}
          type="radio"
          label={item.label}
          aria-label={register.name}
          value={item.value}
          disabled={disabled}
          {...register}
        />
      ))}
    </div>
  );
};

export default RadioButton;
